import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import Title from './Title'
import Explanation from './Explanation'

const Details = ({ factor }) => (
  <div>
    <Title className="m-b-lg" />

    <p><b>{intl.get(`aptitude.questions.bar.${factor}.subtitle_1`)}</b></p>
    <p>{intl.get(`aptitude.questions.bar.${factor}.subtitle_2`)}</p>

    <b>{intl.get('aptitude.questions.bar.information')}</b>
    <Explanation factor={factor} />
  </div>
)

Details.propTypes = {
  factor: PropTypes.string.isRequired,
}

export default Details
